import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';
import { InventoryService } from '../../services/inventory.service';

@Component({
  selector: 'app-inventory-needs-improvements',
  templateUrl: './inventory-needs-improvements.component.html',
  styleUrls: ['./inventory-needs-improvements.component.scss']
})
export class InventoryNeedsImprovementsComponent implements OnInit {
  dataSourceNeedsImprovement: MatTableDataSource<InventoryItem>;
  isLoaded = false;

  columnsToDisplay1 = [
    'code',
    'title'
  ];

  constructor(
    private inventoryService: InventoryService,
    private cdr: ChangeDetectorRef,
    private router: Router) { }

  ngOnInit(): void {
    this.inventoryService.find({status: "Needs Improvement"}, "number", "dsc").subscribe((items: InventoryItem[]) => {
      this.dataSourceNeedsImprovement = new MatTableDataSource<InventoryItem>(items);
      this.cdr.detectChanges();
      this.isLoaded = true;
    });
  }

  viewItem(number: number) {
    this.router.navigate(["inventory", "view-item", number])
  }
}
